import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


export default function AlertDialog(props) {
    const handleClose = () => {
        props.close(false);
        //setisShown(false);
    };

    if (props.isShown) {
        return buildDialog();
    } else {
        return null;
    }

    function buildDialog() {
        return <div>
            <Dialog
                open={true}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {props.Title}
                </DialogTitle>
                <DialogContent>
                    {props.Message}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        {props.CloseText}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    }

       
    
}
